export let saludOcupacional: any[] = [
  {
    id: 1,
    nombre: 'Planes de Seguridad e Higiene Ocupacional.',
    desc: 'La Seguridad y salud laboral o Seguridad y salud en el trabajo tiene por objeto la aplicación de medidas y el desarrollo de las actividades necesarias para la prevención de riesgos derivados del trabajo. ',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 2,
    nombre:
      'Planes y manuales de prevención y evaluación de riesgos laborales.',
    desc: 'La evaluación de riesgos busca identificar y eliminar riesgos presentes en el entorno de trabajo así como la valoración de la urgencia de actuar. La evaluación de riesgos laborales es una obligación empresarial y una herramienta fundamental para la prevención de daños a la salud y la seguridad de los trabajadores.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 3,
    nombre:
      'Prevención y evaluación de riesgos laborales, en sector: Construcción Edificios, condominios, carreteras, puentes, otros.',
    desc: '',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 4,
    nombre:
      'Transportes (Manejo defensivo, Control de derrames, seguridad Vial.',
    desc: 'El Manejo Defensivo y Seguridad Vial genera buenos hábitos en la conducción, mediante un conjunto de normas y acciones de seguridad durante la operación de los vehículos, así́ mismo incentiva el conocimiento de las normas vigentes en el Código Nacional de Transito – Ley 769 / 2002.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 5,
    nombre: 'Industrias (químicas, madera, textil, metal, agropecuario, otros)',
    desc: 'La industria manufacturera incluye la transformación física o química de materiales, de sustancias, o de componentes en productos nuevos, aunque esto no se puede utilizar como el solo criterio universal para definir la industria manufacturera.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 6,
    nombre: 'Servicios (Hotelería, Bancos, Restaurantes)',
    desc: 'Un Servicio son un conjunto de acciones las cuales son realizadas para servir a alguien, algo o alguna causa. Los servicios son funciones ejercidas por las personas hacia otras personas con la finalidad de que estas cumplan con la satisfacción de recibirlos.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 7,
    nombre: 'Manuales de Prevención y Extinción de Incendios.',
    desc: 'Conocer elementos básicos de la química del fuego. Reconocer los agentes extintores de incendio y su aplicación de acuerdo al tipo de combustible a extinguir. Conocer la utilización de los distintos extintores portátiles.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 8,
    nombre: 'Planes de emergencia y evacuación para empresas.',
    desc: 'Planificación y organización humana para la utilización óptima de los medios técnicos previstos, con la finalidad de reducir al mínimo las posibles consecuencias humanas o económicas que pudieran derivarse de la situación de emergencia.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 9,
    nombre: 'Manuales de Primeros Auxilios.',
    desc: 'Es la ayuda inmediata, temporal y necesaria que se le da a una persona que ha sufrido un accidente, enfermedad o agudización de esta hasta la llegada de un médico o profesional paramédico que se encargará, solo en caso necesario, del trasladado a un hospital tratando de mejorar o mantener las condiciones en las que se encuentra.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 10,
    nombre:
      'Formación de Brigadas (contra incendio, primeros auxilio entre otros).',
    desc: 'Se refiere a que la capacitación del personal ya no debe de ser realizada en cronogramas fraccionados y espaciados si no que por el contrario se deben realizar módulos completos en los que se integren diferentes tópicos en escenarios reales, los mismos que se presume enfrentaran alguno día debido a las condiciones irregulares en las que se desarrollan las diferentes actividades, por lo tanto le recomendamos realizar bloques anuales de capacitación certificada.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 11,
    nombre:
      'Realización de simulacros de sismo, incendio, y primeros auxilios.',
    desc: 'Los simulacros de emergencia, también llamados ejercicios prácticos de emergencia, sirven para evaluar los planes de autoprotección y asegurar la eficacia y operatividad de los planes de actuación en emergencias. Se deben realizar con la periodicidad mínima que fije el plan de autoprotección, y en todo caso, al menos una vez al año evaluando sus resultados.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 12,
    nombre:
      'Inspección periodica y diagnóstico en seguridad y Salud ocupacional.',
    desc: '',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 13,
    nombre:
      'Asesoríamiento a observaciones realizadas por el Ministerio de Trabajo.',
    desc: '',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 14,
    nombre:
      'Elaboración de procedimientos, formatos, instructivos, permisos de trabajos críticos.',
    desc: '',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 15,
    nombre:
      'Administración del control de pérdidas de accidentes laborales. (Daños personales, Daños materiales, Daños medio Ambiente)',
    desc: 'Accidentes de trabajo que representan pérdidas en los procesos productivos, causas inmediatas y causas básicas, y pérdidas materiales.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 16,
    nombre: 'Elaboración de reglamento interno y manuales de Seguridad.',
    desc: 'Es el instrumento por medio del cual el empleador regula las obligaciones y prohibiciones a que deben sujetarse los trabajadores, en relación con sus labores, permanencia y vida en la empresa.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 17,
    nombre:
      'Implementación y asesoría en la elaboración de índices . de desempeño en Seguridad.',
    desc: 'Relación entre variables cuantitativas o cualitativas de desempeño de seguridad que permite observar la situación y las tendencias de cambios generadas en los mismos, en relación con objetivos y metas previstas e impactos esperados.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 18,
    nombre: 'Asesoramiento en equipos de protección personal.',
    desc: 'Equipos destinados a ser llevado o sujetado por el trabajador para que lo proteja de uno o más riesgos que puedan amenazar su seguridad y/o su salud, así como cualquier complemento destinado al mismo fin.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 19,
    nombre: 'Asesoramiento en Señalización de seguridad y salud ocupacional.',
    desc: 'Señalización que, relacionada con un objeto, actividad o situación determinada, suministra una indicación, una obligación relativa a la seguridad o la salud en el trabajo mediante un plafón, un color, una señal luminosa, una señal acústica una comunicación verbal o señal gestual.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 20,
    nombre: 'Capacitaciones en temas de seguridad y salud en el trabajo.',
    desc: '',
    img: 'assets/img/app/appimg5.png'
  }
];



// WEBPACK FOOTER //
// G:/proyectos/website - IntergraMAI/webMai/src/assets/saludOcupacional.data.ts